import { newAPI } from '../../../services';

export const fetchTags = async params => {
  const response = await newAPI.get(`/${params.userId}/establishment/${params.establishmentId}/notifications/tags?page=${params.page}`);
  return response.data;
}

export const fetchCategories = async params => {
  const response = await newAPI.get(`/${params.userId}/establishment/${params.establishmentId}/notifications/categories?page=${params.page}`);
  return response.data.data;
}

export const fetchServiceConfig = async params => {
  const response = await newAPI.get(`/${params.userId}/establishment/${params.establishmentId}/notifications/settings/view_by_service?page=${params.page}&notificationCategoryId=${params.notificationCategoryId}&serviceId=${params.serviceId}`);
  return response?.data?.data;
}